import { APP_NAME } from './brand/brandInfo';
import { nestLogo, nestLogoWithName } from './brand/brandLogos';

export const APP_CONSTANTS = {
  APP_NAME,
  BRAND_NAME:'Emmple', 
  APP_URL: 'https://nest.emmple.com',
  APP_LOGO: '/images/nest-logo.svg',
  APP_LOGO_WITH_NAME: '/images/nest-logo-with-name.svg',
  APP_DESCRIPTION: 'School Management System',
  ASSETS: {
    logo: nestLogo,
    logoWithName: nestLogoWithName,
    emmpleLogo: '/images/emmple-logo-new.svg',
    emmpleLogoNoText: '/images/emmple-logo-no-text.svg',
  },
  SUPPORT: {
    EMAIL: 'nest-support@emmple.com',
  }
} as const;

export type AppConstants = typeof APP_CONSTANTS;


